<template>
    <v-card
        :class  = "background"
        :ripple = "false"
        flat
        rounded
    >
        <div
            class = "lm-border pa-3 pt-3"
            style = "position: relative"
            :style="'height:' + height + 'px'"
        >
            <div
                class = "v-flex"
                style = "justify-content: space-between; height: 22px"
            >
                <div
                    v-if="selected && selectable"
                    style="margin-top: -2px; margin-left: -6px;"
                >
                    <a @click="onMinus">
                        <v-icon color="red" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                    </a>
                </div>

                <div
                    v-if="!selected && selectable"
                    style="margin-top: -3px; margin-left: -6px;"
                >
                    <a @click="onPlus">
                        <v-icon color="success" class="toolbar-button" size="20">mdi-plus-box</v-icon>
                    </a>
                </div>

                <div style="font-size: 15px; padding-top: 1px;" class="v-flex">
                    <div>
                        <c-tag
                            :label="contract"
                            :active="true"
                            :background-color="!site.contractLimId || site.limTerminate ? 'orange' : 'primary' "
                        />
                    </div>
                    <div
                        class="ml-1"
                        :class="active ? 'primary--text' : 'lightgray'"
                    >
                        {{ site.fabricNo }}
                    </div>
                </div>
                <v-spacer/>
                <div class="site-customer">
                   {{ site.customer.name }}
                </div>
                <div style="margin-top: -2px; margin-right: -7px;">
                    <c-site-icon
                        :site="site"
                        @selected="onSite(site)"
                    />
                </div>
                <slot name = "toolbar"></slot>
            </div>

            <div style="font-size: 10px">
                bis {{ date (site.contractLimExpiration) }}{{ limPrice }}{{ lgsPrice }}
            </div>
            <v-divider class="mt-1 mb-1" />
            <div class="card-subtitle">
                {{ site.street }}, {{ site.zip }} {{ site.city }}
            </div>
            <div class="card-subtitle">
                {{ site.ve }}  {{ site.ve && site.ve2 ? ' / ' : ''  }}  {{ site.ve2 }} {{ '/ ' + site.ve3 }}
            </div>
            <v-divider class="mt-1 mb-1" v-if="showContractInfo" />

            <div class="v-flex" v-if="showContractInfo">
                <v-card
                    flat
                    class  = "mr-1 w-50 v-flex"
                    :class = "background"
                    style  = "font-size: 12px"
                    @click = "onClick"
                >
                    <c-tag label="W" :active="site.contractMntActive" />
                    <div class="company-name">{{ site.maintenanceCompany }}</div>
                </v-card>
                <v-spacer />
                <div v-if="site.escCompany" class="ml-1 w-50 v-flex" style="font-size: 12px; ">
                    <c-tag label="N" :active="true" />
                    <div class="company-name">{{ site.escCompany }}</div>
                </div>
                <div v-if="!site.escCompany" class="ml-1 w-50 v-flex" style="font-size: 12px; ">
                    <c-tag label="N" :active="false" />
                </div>
            </div>

            <div class="v-flex pt-0-5" v-if="showContractInfo">
                <div class="mr-1 w-50 v-flex company-name" style="font-size: 10px; margin-top: 0; padding-left: 0; margin-left: 0;">
                    <span v-if="site.contractMntExpiration">bis {{ date (site.contractMntExpiration) }}</span>
                    <span v-if="!site.contractMntExpiration && site.maintenanceCompany" class="mr-1 missing-value">---</span>
                    <span v-if="site.maintenanceType" class="ml-1">{{ site.maintenanceType }}</span>
                    <span v-if="!site.maintenanceType && site.maintenanceCompany" class="mr-1 missing-value">---</span>
                    <span v-if="site.contractMntCountPerYear" class="ml-1">{{ site.contractMntCountPerYear }} x Jahr</span>
                    <span v-if="!site.contractMntCountPerYear && site.maintenanceCompany" class="ml-1 missing-value">---</span>
                </div>
                <v-spacer />
                <div v-if="site.escCompany" class="ml-1 w-50 v-flex" style="font-size: 10px; margin-top: 1px">
                    <span v-if="!site.contractEscExpiration" class="ml-0 missing-value" >---</span>
                    <span v-if="site.contractEscExpiration">bis {{ date (site.contractEscExpiration) }}</span>
                </div>
            </div>
            <div>
                <slot name="editor" v-bind:site="site"></slot>
            </div>
        </div>
    </v-card>
</template>

<script>

import Core from "@/modules/core/service/Core";
import CSiteIcon from "@/modules/msd/unit/components/controlls/CSiteIcon";
import Site from "@/modules/msd/unit/service/Site";
import CTag from "@/modules/core/components/utils/CTag";

export default {
    name: "CSiteCard",
    components: {
        CTag,
        CSiteIcon
    },
    props: {
        site: {
            default: function () {
                return {
                    contractLimTypeId: null,
                    limPricePerMonth: null,
                    contractLimExpiration: null,
                    maintenanceCompany: null,
                    maintenanceType: null,
                    contractMntActive: null,
                    contractMntFrequency: null,
                    contractMntExpiration: null,
                    escCompany: null,
                    contractEscExpiration: null,
                }
            },
        },

        selected: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        selectable: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        height: {
        }
    },


    data: () => ({
        showMenu : false
    }),


    computed: {
        active () {
            if (!this.site.status) {
                return false;
            }

            return this.site.status.id === 1;
        },


        background () {
            return this.selected ? "background-selected " : "";
        },

        contract () {

            if (!this.site.contractLimTypeId) {
                return "P";
            }

            switch (this.site.contractLimTypeId) {
                case Site.CONTRACT.LIM:
                    return "LIM";
                case Site.CONTRACT.DLS:
                    return "DLS";
            }

            return "P";
        },

        limPrice () {
            if (!this.site.contractLimTypeId) {
                return null;
            }

            switch (this.site.contractLimTypeId) {
                case Site.CONTRACT.LIM:
                    return " - " + this.money (this.site.limPricePerMonth);
                case Site.CONTRACT.DLS:
                    return "";
            }

            return null;
        },

        lgsPrice () {
            if (!this.site.contractLimTypeId) {
                return null;
            }

            switch (this.site.contractLimTypeId) {
                case Site.CONTRACT.LIM:
                    return this.site.limLgsPerMonth ? " / " + this.money (this.site.limLgsPerMonth) : "";
                case Site.CONTRACT.DLS:
                    return "";
            }

            return null;
        },

        assignUnitMode () {
            return this.$store.getters.assignUnitMode;
        },

        showContractInfo () {
            return !this.site.checked  && !this.assignUnitMode;
        }
    },

    methods: {
        onSite (site) {
            if (site) {
                this.$emit("site", site)
            }
        },

        onMinus () {
            this.$emit("deselect", this.site);
        },

        onPlus () {
            this.$emit("assign", this.site);
        },

        date (value) {
            return Core.format.date.display(value);
        },

        money (value) {
            return Core.format.money(value);
        },

        onClick () {
            this.$emit("click", this.site)
        }
    },
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.site-customer {
    font-size: 13px;
    padding-right: 5px;
    padding-top: 4px;
    max-width: 175px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.missing-value {
    background: orange;
    color: white;
    width: 29px;
    height: 18px;
    text-align: center;
    border-radius: 2px;
    border-color: orange;
    margin-top: -2px;
}

.company-name {
    margin-left: 4px;
    padding-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 35px);
}

</style>